export default __webpack_public_path__ + "static/media/rmc05.c3368a99.png";